import Vue from 'vue';
import simplebar from 'simplebar-vue';

// Simplebar not working if css imported here.
// So, css imported in .src/assets/scss/plugins.scss
// import 'simplebar/dist/simplebar.min.css';

Vue.component('simplebar', simplebar);
